module.exports = __webpack_public_path__ + "img/album19_09.230f5650.jpg";